<hpf-activity-log-form
	*ngIf="activityLog"
	[activityLog]="activityLog"
	(create)="onCreate($event)"
></hpf-activity-log-form>
<div *ngIf="!activityLog" class="my-5 text-center">
	<nz-spin nzSimple></nz-spin>
</div>
